<template>
  <div
    v-if="media"
    class="c-media-display-carousel"
  >
    <div
      class="l-flex l-flex--align-start l-flex--justify-start"
      role="contentinfo"
    >
      <nav
        v-if="media.length > 1 && (!gridLayout || isMobile)"
        class="c-media-display-carousel__menu l-flex l-flex--column"
        role="menu"
      >
        <template v-for="(asset, index) in media">
          <button
            v-if="index < 6"
            :key="index"
            role="menuitem"
            class="c-media-display-carousel__menu-item l-flex"
            :class="forceMobile ? 'u-hidden' : 'u-hidden-mobile'"
            @click="displayMedia = asset; goToSlide(index)"
          >
            <img
              v-if="asset.type == 'image'"
              class="c-media-display-carousel__menu-media"
              :src="asset.thumbnailSrc"
              :alt="asset.alt || 'click to see ' + asset.type + ' ' + (index+1)"
            >
            <div
              v-else-if="asset.type == 'video'"
              class="c-media-display-carousel__menu-video-container"
              :aria-label="asset.alt || asset.type"
            >
              <img
                class="c-media-display-carousel__menu-media"
                :src="asset.thumbnailSrc"
                :alt="asset.alt || 'click to see ' + asset.type + ' ' + (index+1)"
              >
              <img
                class="c-media-display-carousel__menu-video-icon"
                src="~@/assets/icons/play.svg"
                alt="Play"
                aria-label="video."
              >
            </div>
          </button>
        </template>
      </nav>
      <div class="l-flex__item">
        <div :class="displayContainer">
          <client-only>
            <flickity
              v-if="flickityActive && (!gridLayout || isMobile)"
              :key="media.length"
              ref="flickity"
              class="flickity"
              :options="flickityOptions"
            >
              <template v-for="(item, index) of media">
                <div
                  v-if="index < 6"
                  :key="index"
                  class="carousel-cell"
                >
                  <Badge
                    v-if="clearance"
                    background-class="u-background-color-primary"
                    class="u-z-index-1 c-media-display-carousel__display-badge"
                  >
                    Clearance
                  </Badge>
                  <div
                    v-if="item.src"
                    class="l-flex u-margin-bottom-medium"
                    :class="displayClass"
                  >
                    <nuxt-img
                      v-if="(item.type == 'image') && item.src"
                      class="c-media-display-carousel__display-media"
                      :src="item.src"
                      :alt="item.alt ||'Product image'"
                      preset="display-carousel"
                      sizes="xl:600px md:450px"
                    />
                    <vid
                      v-else-if="item.type == 'video'"
                      v-bind="item"
                    />
                    <p
                      v-if="mediaTitle && item.type != 'video'"
                      class="c-media-display-carousel__display-title"
                    >
                      {{ mediaTitle }}
                    </p>
                  </div>
                </div>
              </template>
            </flickity>
            <div
              v-else-if="gridLayout && !isMobile"
              class="l-grid l-grid--2-col"
            >
              <template v-for="(item, index) in media">
                <div
                  :key="index.id"
                  class="l-flex"
                  :class="index == 0 ? displayClass: 'c-media-display-carousel__display--grid'"
                >
                  <Badge
                    v-if="clearance && index == 0"
                    background-class="u-background-color-primary"
                    class="u-z-index-1 c-media-display-carousel__display-badge"
                  >
                    Clearance
                  </Badge>
                  <img
                    v-if="item.type == 'image'"
                    class="c-media-display-carousel__display-media"
                    :src="item.src"
                    :alt="item.alt || 'Display image'"
                    format="webp"
                    quality="90"
                    sizes="xl:400px md:250px"
                  >
                  <vid
                    v-else-if="item.type == 'video'"
                    v-bind="item"
                  />
                  <p
                    v-if="mediaTitle && item.type != 'video'"
                    class="c-media-display-carousel__display-title"
                  >
                    {{ mediaTitle }}
                  </p>
                </div>
              </template>
            </div>
            <div
              v-else
              class="l-flex"
            >
              <template v-for="(item, index) in media">
                <div
                  v-if="displayMedia"
                  :key="index.id"
                  class="l-flex u-margin-bottom-medium"
                  :class="displayClass"
                >
                  <Badge
                    v-if="clearance"
                    background-class="u-background-color-primary"
                    class="u-z-index-1 c-media-display-carousel__display-badge"
                  >
                    Clearance
                  </Badge>
                  <img
                    v-if="item.type == 'image'"
                    class="c-media-display-carousel__display-media"
                    :src="item.src"
                    :alt="item.alt || 'Display image'"
                    format="webp"
                    quality="90"
                    sizes="xl:600px md:450px"
                  >
                  <vid
                    v-else-if="item.type == 'video'"
                    v-bind="displayMedia"
                  />
                  <p
                    v-if="mediaTitle && item.type != 'video'"
                    class="c-media-display-carousel__display-title"
                  >
                    {{ mediaTitle }}
                  </p>
                </div>
              </template>
            </div>
          </client-only>
          <nav
            v-if="!gridLayout"
            class="c-media-display-carousel__menu l-flex"
            role="menubar"
          >
            <template v-for="(asset, index) in media">
              <button
                v-if="index < 6"
                :key="index"
                role="menuitem"
                class="c-media-display-carousel__menu-item l-flex"
                :class="forceMobile ? '' : 'u-hidden-desktop u-hidden-desktop--flex'"
                @click="displayMedia = asset; goToSlide(index)"
              >
                <img
                  v-if="asset.type == 'image'"
                  class="c-media-display-carousel__menu-media"
                  :src="asset.thumbnailSrc"
                  :alt="asset.alt || 'click to see ' + asset.type + ' ' + (index+1)"
                >
                <div
                  v-else-if="asset.type == 'video'"
                  class="c-media-display-carousel__menu-video-container"
                >
                  <img
                    class="c-media-display-carousel__menu-media"
                    :src="asset.thumbnailSrc"
                    :alt="asset.alt || 'click to see ' + asset.type + ' ' + (index+1)"
                  >
                  <img
                    class="c-media-display-carousel__menu-video-icon"
                    src="~@/assets/icons/play.svg"
                    alt="Play"
                  >
                </div>
              </button>
            </template>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vid from "../video/Vid";
import Badge from "../badge/Badge";
import flickityActive from '../carousel/flickityActive'
import isMobile from '@mixins/isMobile';

export default {
  name: "MediaDisplayCarousel",
  components: {
    Vid,
    Badge
  },
  mixins: [
    flickityActive,
    isMobile
  ],
  props: {
    media: {
      type: Array,
      default: () => []
    },
    mediaTitle: {
      type: String,
      default: null
    },
    forceMobile: {
      type: Boolean,
      default: false
    },
    availableForSale: {
      type: Boolean,
      default: true
    },
    clearance: {
      type: Boolean,
      default: false
    },
    gridLayout: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      displayMedia: {},
      flickityOptionsDefault: {
        initialIndex: 0,
        prevNextButtons: false,
        pageDots: true,
        wrapAround: true,
        dragable: true,
        imagesLoaded: true,
        fullscreen: true,
        // any options from Flickity can be used
        // https://flickity.metafizzy.co/options.html
      },
      flickityOptionsGrid: {
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: true,
        wrapAround: true,
        dragable: true,
        imagesLoaded: true,
        fullscreen: true,
      }
    }
  },
  computed: {
    displayContainer() {
      let result = "c-media-display-carousel__display-container"
      const gridLayout = this.gridLayout
      const isMobile = this.isMobile
      if(gridLayout && !isMobile) {
        result += '--grid'
      }
      return result
    },
    flickityOptions() {
      let results = this.flickityOptionsDefault
      const gridResults = this.flickityOptionsGrid
      const isMobile = this.isMobile
      const gridLayout = this.gridLayout
      if(gridLayout && isMobile) {
        results = gridResults
      }
      return results
    },
    displayClass() {
      let results = 'c-media-display-carousel__display'
      const gridLayout = this.gridLayout
      const isMobile = this.isMobile
      if(gridLayout && !isMobile) {
        results += ' c-media-display-carousel__display--grid'
      }
      if (this.availableForSale == false) {
        results +=  ' c-media-display-carousel__display--oos'
      }
      if (this.forceMobile) {
        results +=  ' c-media-display-carousel__display--cart'
      }
      return results;
    },
  },
  watch: {
    async media() {
      if (this.media) {
        this.displayMedia = this.media[0];
      }
      await this.$nextTick()
      this.flickityActivator()
      if (this.$refs.flickity) {
        this.$refs.flickity.rerender()
      }
    }
  },
  created() {
    if (this.media) {
      this.displayMedia = this.media[0];
    }
  },
  methods: {
    goToSlide(slideNumber) {
      if (this.media.length > 1) {
        this.$refs.flickity.$flickity.select(slideNumber);
      }
      // if you want the slide not to animate
      // this.$refs.flickity.$flickity.select(slideNumber, false, true);
    },
    flickityActivator() {
      if (this.media.length > 1) {
        this.flickityActive = true;
        return
      }
      this.flickityActive = false;
      return
    }
  }
}
</script>

<style lang="scss" scoped>
.c-media-display-carousel {
  &__menu {
    padding-top: rem(50px);
  }
  &__menu-item {
    width: rem(55px);
    height: rem(55px);
    margin-right: rem(15px);
    padding: rem(5px);
    margin-bottom: rem(10px);

    @include themify($themes) {
      background: themed('background', 'base');
      border: $border themed('foreground', 'section-border');
    }

    &:hover {
      cursor: pointer;
    }
  }

  &__menu-media {
    max-width: 100%;
  }

  &__menu-video-container {
    position: relative;
    width: rem(43px);
    height: rem(43px);
  }

  &__menu-video-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: rem(33px);
    height: rem(33px);
  }

  &__display {
    position: relative;
    width: rem(565px);
    height: rem(565px);
    max-width: 100%;

    @include  respond(phone) {
      width: 100%;
    }

    @include themify($themes) {
      background-color: themed('background', 'xx-light')
    }

    &--grid {
      width: rem(380px);
      height: rem(380px);
    }

    &--cart {
      width: rem(300px);
      height: rem(300px);
    }

    &--oos {
      &:before {
        content: '';
        z-index: 5;
        width: 100%;
        height: 100%;
        position: absolute;
        @include themify($themes) {
          background-color: themed('background', 'light');
          opacity: .5;
        }
      }
      &:after {
        content: 'this size is out of stock';
        font-size: rem(30px);
        line-height: rem(38px);
        letter-spacing: rem(2px);
        font-weight: $font-weight-medium;
        text-transform: uppercase;
        @include themify($themes) {
          color: themed('foreground');
        }
        text-align: center;
        z-index: 6;
        width: 100%;
        position: absolute;
      }
    }
  }

  &__display-badge {
    top: 0;
    left: 0;
  }

  &__display-media {
    width: 100%;
    max-height: 100%;
    margin: auto;
    object-fit: cover;
  }

  &__display-title {
    position: absolute;
    bottom: 10px;
    left: 10px;
    @include themify($themes) {
      color: themed('foreground', 'x-light-text')
    }
  }

  .carousel-cell {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .carousel-cell img {
    display: block;
    max-width: 100%;
  }


  &__display-container {
    width: rem(565px);
    height: auto;
    max-width: 92vw;
    &--grid {
      width: rem(400px)
    }
  }
}
</style>
